import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { usePublicFormBySlug } from '../../hooks/useForms';
import { FormTypeform } from './FormTypeform';

export const FormPublicBySlug: React.FC = () => {
  const { userHandle, slug } = useParams<{ userHandle: string; slug: string }>();

  // Vanity URLs must start with @, otherwise it's not a form route
  const username = userHandle?.startsWith('@') ? userHandle.slice(1) : null;

  if (!username) {
    // Not a vanity URL — let other routes handle it or show 404
    return <Navigate to="/dashboard" replace />;
  }

  return <FormPublicBySlugInner username={username} slug={slug} />;
};

// Inner component so the hook is only called with a valid username
const FormPublicBySlugInner: React.FC<{ username: string; slug: string | undefined }> = ({ username, slug }) => {
  const { form, loading, error, submitResponse } = usePublicFormBySlug(username, slug);

  if (loading) {
    return (
      <div className="h-dvh flex items-center justify-center bg-neutral-950 overflow-hidden">
        <Loader2 className="w-8 h-8 text-primary-500 animate-spin" />
      </div>
    );
  }

  if (error === 'form_owner_inactive') {
    return (
      <div className="h-dvh flex flex-col items-center justify-center bg-neutral-950 text-white p-4 overflow-hidden">
        <AlertCircle className="w-16 h-16 text-neutral-500 mb-4" />
        <h1 className="text-2xl font-bold mb-2">Formulario indisponivel</h1>
        <p className="text-neutral-400 text-center max-w-md">
          Este formulario esta temporariamente fora do ar. Entre em contato com o responsavel.
        </p>
      </div>
    );
  }

  if (error || !form) {
    return (
      <div className="h-dvh flex flex-col items-center justify-center bg-neutral-950 text-white p-4 overflow-hidden">
        <AlertCircle className="w-16 h-16 text-neutral-500 mb-4" />
        <h1 className="text-2xl font-bold mb-2">Formulário não encontrado</h1>
        <p className="text-neutral-400 text-center max-w-md">
          Verifique se o link está correto. O formulário pode ter sido removido
          ou o link pode ter sido alterado pelo criador.
        </p>
      </div>
    );
  }

  return <FormTypeform form={form} onSubmit={submitResponse} />;
};
